import { render } from "./HomeWorks.vue?vue&type=template&id=0dd9bbff&scoped=true"
import script from "./HomeWorks.vue?vue&type=script&lang=js"
export * from "./HomeWorks.vue?vue&type=script&lang=js"

import "./HomeWorks.vue?vue&type=style&index=0&id=0dd9bbff&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd9bbff"]])

export default __exports__